export const config = {
  fontsPath: '/assets/fonts',
} as const;
